import database, { firebase } from '../../system/model/firebase/firebase';
import { companyTypes, getCompanyUsers } from './company_action';
import { NotificationManager } from 'react-notifications';
import { startSetCompany } from './platformAction';
export const authTypes = {
  LOGIN: 'authorize/LOGGING_IN',
  SIGNOUT: 'authorize/DEAUTHORIZE',
  ADMINSESSION: 'authorize/ADMIN_IN',
  ADMINSIGNOUT: 'authorize/ADMIN_DEAUTHORIZE',
  COMPANYSESSION: 'authorize/COMPANY_IN',
  COMPANYSIGNOUT: 'authorize/COMPANY_DEAUTHORIZE',
  ISABLETO: 'authorize/REQUEST_VACANCY',
  SILENCETRIGGER: 'authorize/SILENCE_TRIGGER',
  FETCH_COMPANY_DATA: 'company/GETTING_DATA',
  FETCH_VACANCY_DATA: 'jobs/GETTING_DATA',
  GETTING_COMPANIES: 'admin/GETTING_COMPANIES',
};

export const getCompanies = (companies) => ({
  type: authTypes.GETTING_COMPANIES,
  companies,
});

export const setVacancies = (vacancies) => ({
  type: authTypes.FETCH_VACANCY_DATA,
  vacancies,
});

export const login = (uid, claim, user) => ({
  type: authTypes.LOGIN,
  uid,
  claim,
  userData: { ...user },
});
export const isAbleToGet = (isAbleTo) => ({
  type: authTypes.ISABLETO,
  isAbleTo,
});
export const adminLogin = (uid, claim, user) => ({
  type: authTypes.ADMINSESSION,
  uid,
  claim,
  userData: { ...user },
});

export const companyLogin = (uid, claim, user, claims, platform) => async (dispatch, getState) => {
  try {
    const dataUser = await database
      .collection(`${platform}/data/companiesUsers`)
      .where('email', '==', user?.email)
      .get();
    dispatch({
      type: authTypes.COMPANYSESSION,
      uid: dataUser.docs[0]?.data()?.objectID || uid,
      claim,
      userData: { ...user },
      claims,
    });
  } catch (e) {
    NotificationManager.error('Error al iniciar sesion, favor de comunicarse con LaPieza.io');
  }
};

export const logout = () => ({
  type: authTypes.SIGNOUT,
});

export const adminLogout = () => ({
  type: authTypes.ADMINSIGNOUT,
});
export const companyLogout = () => ({
  type: authTypes.COMPANYSIGNOUT,
});

export const startLogout = () => (dispatch) => {
  firebase.auth().signOut();
  // window.location.reload(true);
  dispatch({
    type: authTypes.COMPANYSIGNOUT,
  });
};

export const setCompany = (data) => ({
  type: companyTypes.PUBLISH_DATA,
  data,
});
